import React from "react";

const Pagination = ({ pages, currentPage, prevPageClick, changePage, nextPageClick ,firstPageClick , endPageClick, lastPage}) => {
  return (
    pages.length > 1 && (
      <ul className="pagination mt-4">
        {currentPage > 1 && (
          <>
            <li
              onClick={(e) => {
                changePage(e,1);
              }}
              className="page-item"
            >
              <a className="page-link" href="#">
                <span>{`<<`}</span>
              </a>
            </li>
            <li
              onClick={(e) => {
                prevPageClick(e);
              }}
              className="page-item"
            >
              <a className="page-link" href="#">
                <span>{`<`}</span>
              </a>
            </li>
          </>

        )}
        {pages
          .filter((page) => Math.abs(page - currentPage) < 3)
          .map((page, index) => (
            <li
              key={index}
              onClick={(e) => changePage(e, page)}
              className={"page-item" + (page == currentPage ? " active" : "")}
            >
              <a className="page-link" href="#">
                {page}
              </a>
            </li>
          ))}
        {pages.length > currentPage + 3 && (
          <>
            <li className={"page-item"}>
              <a className="page-link">
                ...
              </a>
            </li>
            <li
              onClick={(e) => changePage(e, pages.length)}
              className={"page-item"}
            >
              <a className="page-link" href="#">
                {pages.length}
              </a>
            </li>
          </>
        )}
        {pages.length != currentPage && (
          <>
            <li
              onClick={(e) => {
                nextPageClick(e);
              }}
              className="page-item"
            >
              <a className="page-link" href="#">
                <span>{` >`}</span>
              </a>
            </li>
            <li
              onClick={(e) => {
                changePage(e,lastPage);
              }}
              className="page-item"
            >
              <a className="page-link" href="#">
                <span>{`>>`}</span>
              </a>
            </li>
          </>
        )}
      </ul>
    )
  );
}

export default Pagination;